import {Typography, Divider, Box} from '@mui/material';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import eLibraryDocument from '../../../types/legal/eLibraryDocument';
import LegalTable from './LegalTable';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';

const InterpretiveBulletinIndex = (): JSX.Element => {

  document.title = 'OCPF - Interpretive Bulletins';

const interpretiveBulletins: eLibraryDocument[] =[
  {
    id: 1,
    year: 2010,
    pdfFileName: "IB-10-04",
    title: "Subvendor Reports",
    description: "This bulletin is issued to provide guidance and direction to political committees and interested persons regarding the interpretation and implementation of those sections of the campaign finance law relating to the filing of subvendor reports. The law requires political committees to disclose how their paid consultants and vendors make expenditures on their behalf.",
  },
  {
    id: 2,
    year: 2010,
    pdfFileName: "IB-10-03",
    title: "Independent Expenditure Political Action Committees",
    description: "This bulletin is issued to provide guidance and direction to groups that raise funds solely to make independent expenditures.",
  },
  {
    id: 3,
    year: 2010,
    pdfFileName: "IB-10-02",
    title: "Filing of Late Contribution Reports",
    description: "This bulletin is issued to provide guidance and direction to political committees and interested persons regarding the interpretation and implementation of the campaign finance law as it applies to the filing of late contribution reports.",
  },
  {
    id: 4,
    year: 2006,
    pdfFileName: "IB-06-01",
    title: "Express Advocacy and Issue Advocacy, Independent Expenditures, Electioneering Communications and Coordinated Communications",
    description: "This interpretive bulletin defines 'express advocacy' and 'issue advocacy' and provides guidance regarding whether communications that might be considered either 'express advocacy' or 'issue advocacy' involve the making of expenditures or the receipt of contributions subject to the requirements of the Massachusetts campaign finance law. In addition, the bulletin summarizes the impact of 'coordination' on communications that would otherwise be issue advocacy, independent expenditure communications, or electioneering communications.",
  },
  {
    id: 5,
    year: 2004,
    pdfFileName: "IB-04-01",
    title: "Use of Internet and E-mail for Political Campaign Purposes",
    description: "This bulletin summarizes OCPF's responses to questions relating to expenditures that may be made for Internet access, the services that may be provided to candidates and committees to help them establish websites, the use of links to campaign websites, the use of the Internet to receive contributions, and access to government websites and e-mail networks.",
  },
  {
    id: 6,
    year: 1995,
    pdfFileName: "IB-95-02",
    title: "Political Activity, Organization & Dissolution of Ballot Question Committees and Civic Organizations' Involvement in Ballot Question Campaigns",
    description: "This bulletin defines the range of political activity which may be undertaken by ballot question committees, the organization and dissolution of such committees, and the relationship between ballot question campaigns and civic organizations.",
  },
  {
    id: 7,
    year: 1994,
    pdfFileName: "IB-94-02",
    title: "Requirements of the Campaign Finance Law Relating to Political Action Committees",
    description: "This bulletin is issued to provide guidance and direction to political committees and interested persons regarding the interpretation and implementation of certain provisions of the campaign finance law relating to political action committees ('PACs') and related entities.",
  },
  {
    id: 8,
    year: 1992,
    pdfFileName: "IB-92-02",
    title: "Activities of Public Officials in Support of or Opposition to Ballot Questions",
    description: "This bulletin provides guidance regarding the extent to which an appointed or elected official may utilize governmental resources when speaking or acting in support of or opposition to a ballot question. In general, appointed officials may act or speak out about a ballot question in their official capacity during work hours if in doing so they are acting within the scope of their official responsibilities. Elected officials may address or advocate any position on any matter of public policy, including the subject matter of a ballot question, and such speech or advocacy may take place during work hours. Like an appointed official, however, an elected official may not use public resources to promote or oppose a ballot question.",
  },
  {
    id: 9,
    year: 1992,
    pdfFileName: "IB-92-01",
    title: "The Application of the Campaign Finance Law to Political Fundraising by Public Employees",
    description: "This bulletin provides guidance and answers to appointed public employees concerning fundraising. Public employees are prohibited from soliciting or receiving contributions for any political purpose. The bulletin also addresses issues concerning public employees who also run for elected office.",
  },
  {
    id: 10,
    year: 1991,
    pdfFileName: "IB-91-01",
    title: "The Use of Governmental Resources for Political Purposes",
    description: "This bulletin provides general guidance and answers certain frequently asked questions regarding the use of governmental resources for political purposes. Although the discussion and examples are primarily drawn from ballot question campaigns, and most frequently relate to the distribution of information to voters regarding a ballot question, much of the discussion also applies in other contexts where governmental resources are used for political purposes.",
  },
  {
    id: 11,
    year: 1990,
    pdfFileName: "IB-90-02",
    title: "Disclosure and Reporting of Contributions and/or Expenditures Related to Ballot Questions",
    description: "This Bulletin defines when expenditures to influence a ballot question become subject to the campaign finance law and provides guidelines regarding the disclosure of expenditures made to promote or oppose a ballot question by ballot question committees and by other organizations.",
  },
  {
    id: 12,
    year: 1988,
    pdfFileName: "IB-88-02",
    title: "Lease of Real or Personal Property by Candidates and Political Committees",
    description: "This bulletin provides guidelines to candidates and political committees regarding the lease of real or personal property by candidates and political committees. Candidates and political committees which follow these guidelines will ensure that rental expenses for office space and equipment comply with the campaign finance law's record keeping requirements and restrictions against personal use.",
  },
  {
    id: 13,
    year: 1983,
    pdfFileName: "IB-83-01",
    title: "Filing of Reports by PACs and People's Committees organized with OCPF which participate in Municipal Elections",
    description: "This bulletin advises that PACs and People's Committees organized with OCPF or at the municipal level generally do not have additional reporting responsibilities at the municipal level or OCPF.",
  },
  {
    id: 14,
    year: 1982,
    pdfFileName: "IB-82-01",
    title: "The Applicability of MA Campaign Finance Law to Unregistered Political Groups & Non-MA Political Committees",
    description: "This bulletin provides guidance regarding the participation of political committees, especially PACs, organized in another state or at the federal level in Massachusetts elections.",
  },
];



  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
      <Typography
                variant="h5"
                align={'left'}
                data-aos={'fade-up'}
                gutterBottom
                sx={{
                  fontWeight: 700,
                }}
                paddingTop={3}>
                 OCPF Interpretive Bulletins
              </Typography>



    
        <Divider/>
        <Box sx={{marginTop: 2, marginBottom: 4}}>
            <Typography variant="h6" align={'left'} paddingTop={1} paddingLeft={2} fontWeight={'bold'}>
            What is an Interpretive Bulletin?
              </Typography>
              <Typography variant="body1" align={'left'} paddingLeft={2} paddingRight={2}>
              An interpretive bulletin may clarify an aspect of the campaign finance law or provide guidance on how OCPF administers the law in a particular situation.
              </Typography>
              <Typography variant="body1" align={'left'} paddingLeft={2} paddingRight={2}>
              OCPF periodically issues and revises interpretive bulletins on various topics.
              </Typography>
        </Box>
        <LegalTable eLibraryDocuments={interpretiveBulletins}/>

      </Container>
    </Main>
  );
};

export default InterpretiveBulletinIndex;